import React from "react";
import LegalLayout from "./_LegalLayout";

const Accessibility = () => (
  <LegalLayout
    testId="page-accessibility"
    overline="Legal · Accessibility"
    title="Accessibility Statement"
    lead="Allinstra aims to make its website readable, navigable, and usable for a broad range of visitors."
  >
    <p>
      We intend to improve content structure, responsive layout, form usability, and overall
      clarity over time.
    </p>
    <p>
      If you encounter an accessibility issue, please contact:{" "}
      <a href="mailto:info@allinstra.com" className="underline">info@allinstra.com</a>
    </p>
  </LegalLayout>
);

export default Accessibility;
